import styled, { css } from 'styled-components';

export const flexColCSS = css`
  display:flex;
  flex-direction: column;
`;

export const flexRowCSS = css`
  display:flex;
  flex-direction: row;
`;

export const Wrapper = styled.div`
  ${flexColCSS}
  height: 100%;
  padding: 8px;
  position: relative;
  align-items: center;
  justify-content: center;
`;

export const ContentWrapper = styled.span`
  ${flexRowCSS}
  width: 100%;
  flex: 1;
  overflow: hidden;
`;

export const TableWrapper = styled.div`
  ${flexColCSS}
  height: 100%;
  width: 100%;
  background-color: #ffffff;
`;

export const FlexFiller = styled.div`
  display: flex;
  flex: 1;
`;
